/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ClaimHistory
 */
export interface ClaimHistory {
  /**
   *
   * @type {number}
   * @memberof ClaimHistory
   */
  timestamp?: number
  /**
   *
   * @type {boolean}
   * @memberof ClaimHistory
   */
  isClaimedFromDex?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ClaimHistory
   */
  isCompleted?: boolean
  /**
   *
   * @type {string}
   * @memberof ClaimHistory
   */
  txHash?: string
  /**
   *
   * @type {number}
   * @memberof ClaimHistory
   */
  amountInNmx?: number
}

export function ClaimHistoryFromJSON(json: any): ClaimHistory {
  return ClaimHistoryFromJSONTyped(json, false)
}

export function ClaimHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimHistory {
  if (json === undefined || json === null) {
    return json
  }
  return {
    timestamp: !exists(json, 'timestamp') ? undefined : json['timestamp'],
    isClaimedFromDex: !exists(json, 'isClaimedFromDex') ? undefined : json['isClaimedFromDex'],
    isCompleted: !exists(json, 'isCompleted') ? undefined : json['isCompleted'],
    txHash: !exists(json, 'txHash') ? undefined : json['txHash'],
    amountInNmx: !exists(json, 'amountInNmx') ? undefined : json['amountInNmx'],
  }
}

export function ClaimHistoryToJSON(value?: ClaimHistory | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    timestamp: value.timestamp,
    isClaimedFromDex: value.isClaimedFromDex,
    isCompleted: value.isCompleted,
    txHash: value.txHash,
    amountInNmx: value.amountInNmx,
  }
}
